import React, { useEffect } from 'react';
/**
 * Main application component that handles routing for the careers page
 * and job details page. Uses react-router-dom for navigation between pages
 * and renders everything within the shared Layout component.
 */
/**
 * The application uses a consistent Layout wrapper that includes:
 * - Navbar at the top
 * - Main content area that grows to fill available space
 * - Footer at the bottom
 * This ensures a consistent user experience across all pages.
 */
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { CareersPage } from './components/careers/CareersPage';
import { JobDetailsPage } from './pages/JobDetailsPage';
import { Layout } from './components/Layout';
export function App() {
  useEffect(() => {
    window.location.href = 'https://www.magicpatterns.com/careers';
  }, []);
  return null;
}